import { apiClient, getErrorMessage } from '../../utils/apiClient';
import { logger } from '../../utils/logger';
import { API_USER_EVENT_LOGS_MY, API_ADMIN_USER_EVENT_LOGS } from '../../constants/apiConstants';

export interface UserEventLog {
  id: number;
  sysUserId?: number;
  username?: string;
  actorType: string;
  actorId: string;
  tenantId?: number;
  eventType: string;
  eventCategory: string;
  eventStatus: string;
  resourceType?: string;
  resourceId?: string;
  description?: string;
  ipAddress?: string;
  correlationId?: string;
  sessionId?: string;
  durationMs?: number;
  createdAt: string;
}

export interface UserEventLogListParams {
  eventCategory?: string;
  eventType?: string;
  actorType?: string;
  eventStatus?: string;
  sysUserId?: number;
  startDate?: string;
  endDate?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface UserEventLogListResponse {
  logs: UserEventLog[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export const userEventLogService = {
  async getMyEvents(params: UserEventLogListParams = {}): Promise<UserEventLogListResponse> {
    try {
      const response = await apiClient.get(API_USER_EVENT_LOGS_MY, { params });
      if (!response.data.succeeded) throw new Error(response.data.messages?.join(', '));
      return response.data.data;
    } catch (error) {
      logger.error('Failed to fetch user event logs', error);
      throw error;
    }
  },

  async getAllEvents(params: UserEventLogListParams = {}): Promise<UserEventLogListResponse> {
    try {
      const response = await apiClient.get(API_ADMIN_USER_EVENT_LOGS, { params });
      if (!response.data.succeeded) throw new Error(response.data.messages?.join(', '));
      return response.data.data;
    } catch (error) {
      logger.error('Failed to fetch admin user event logs', error);
      throw error;
    }
  },

  getErrorMessage,
};
